"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataListFilter = void 0;
var React = require("react");
var DataListFilter = (function (_super) {
    __extends(DataListFilter, _super);
    function DataListFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.html_id = null;
        _this.header = null;
        _this.formElement = null;
        _this.FilterHeader = function (props) { return (React.createElement("div", { className: "m-2" },
            React.createElement("form", { id: _this.html_id + "_list_filter", ref: function (me) {
                    if (me && !_this.formElement)
                        _this.formElement = me;
                } },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-12" },
                        React.createElement("div", { className: "FilterContainer" },
                            React.createElement("div", { className: "header" },
                                React.createElement("h3", null, _this.header)),
                            React.createElement("div", { id: _this.html_id + '_filter' }, props.children))))))); };
        _this.get_filter_option = function (option_name, default_value) {
            if (default_value === void 0) { default_value = []; }
            if (!_this.props.filter_options ||
                !_this.props.filter_options.hasOwnProperty(option_name)) {
                return default_value;
            }
            return _this.props.filter_options[option_name];
        };
        _this.inputElementChange = function (e) {
            _this.props.changeHandler(e.currentTarget.name, e.currentTarget.value);
        };
        _this.checkboxChange = function (e) {
            _this.props.changeHandler(e.currentTarget.name, e.currentTarget.checked ? 'on' : null);
        };
        _this.userFieldChange = function (udf_type, udf_values) {
            _this.props.changeHandler(udf_type, udf_values);
        };
        return _this;
    }
    return DataListFilter;
}(React.Component));
exports.DataListFilter = DataListFilter;
